// Theme initialization - sets required global variables
let cartIcon = "bag";

if (typeof window.isModalOpened === 'undefined') {
  window.isModalOpened = false;
}

// These values MUST match what global.js expects
window.allSliders = 'allSliders';
window.t = 3;
window.p = 'ov';
window.y = 5;
window.n = 0;
window.productCartForm = 'productCartForm';
